import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import NameField from 'components/forms/new/formikFormFields/NameField';

const CallingRateNameField = ({ darkMode, errors, touched, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.name && touched.name}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Name <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter a name for this calling rate.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <Box sx={{ display: 'flex', width: '100%', alignItems: 'flex-start', paddingTop: '8px' }}>

                        <VStack width="100%" alignItems="normal">
                            <Field
                                component={NameField}
                                id="name"
                                name="name"
                                validate={value => !value && 'Name is required'}
                                error={errors.name}
                                {...props}
                            />
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter a name."
                        ariaLabel="calling-rate-name-tip"
                        left="25px"
                        top="30px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default CallingRateNameField;
